<template>
<div>
  <b-modal v-bind:id="modId" v-bind:title="titleMsg" hide-footer>
    <p class="my-4">{{ msg }}</p>
    <b-button variant="primary" block @click='confirmModal'>{{ buttonMsg }}</b-button>
  </b-modal>
</div>
</template>
<script>
export default {
  name: 'Modal',
  props: ['modId', 'titleMsg', 'msg', 'buttonMsg'],
  methods: {
    confirmModal () {
      this.$emit('confirm')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfirmModal.vue